module.exports = __webpack_public_path__ + "res/29-img_timer.0ab95919dd2e04a83723a533acb00ad9.png";